module.exports = __webpack_public_path__ + "img/theCover_01.b4cdabb2.jpg";